export const getLabelParts = (description) => {
    const parts = description.split('*');
    parts.shift();
    return parts.reduce((acc, label, index) => {
        const isSuggestionType = index % 2 === 0;
        const part = { isSuggestionType, label };
        return [...acc, part];
    }, []);
};
export const getSpanElement = (label) => {
    const element = document.createElement('span');
    element.textContent = label;
    element.className = 'ck-suggestion-type';
    return element;
};
export const getTextElement = (label) => document.createTextNode(label);
export const getNodes = (parts) => parts.map(({ isSuggestionType, label }) => isSuggestionType ? getSpanElement(label) : getTextElement(label));
export const removeAllChildNodes = (parent) => {
    while (parent.firstChild) {
        parent.removeChild(parent.firstChild);
    }
};
export const updateView = (view, description) => {
    const parts = getLabelParts(description);
    const nodes = getNodes(parts);
    const { element } = view;
    if (!element) {
        return;
    }
    removeAllChildNodes(element);
    nodes.forEach(node => {
        element.appendChild(node);
    });
};
